<template>
	<div class="news-wrap">
		<el-form label-width="100px" :model="form" ref="form" :rules="rules">
			<el-form-item label="活动标题" prop="title">
				<el-input v-model="form.title" placeholder="默认活动标题(创建后请修改)" />
			</el-form-item>
			<el-form-item label="投票时间" prop="vote_time">
				<el-col :span="6">
					<el-date-picker
					      v-model="vote_time"
					      type="datetime"
						 value-format="timestamp"
					      placeholder="选择投票时间"
						  @change="toggleVotetime"
						  >
					</el-date-picker>
				</el-col>
				<el-col class="line" :span="1">-</el-col>
				<el-col :span="6">
						<!--  -->
					<el-date-picker
					      v-model="vote_time_end"
					      type="datetime"
						  value-format="timestamp"
						   @change="toggleVoteEndTime"
					      placeholder="选择投票截止时间">
					    </el-date-picker>
				</el-col>
			</el-form-item>
			<el-form-item label="报名时间" prop="enroll_time">
				<el-col :span="6">
					<el-date-picker
					      v-model="enroll_time"
					      type="datetime"
						  value-format="timestamp"
					      placeholder="选择报名时间"
						  @change="toggleEnroll_time">
					    </el-date-picker>
				</el-col>
				<el-col class="line" :span="1">-</el-col>
				<el-col :span="6">
					<el-date-picker
					      v-model="enroll_time_end"
					      type="datetime"
						 value-format="timestamp"
					      placeholder="选择报名结束时间"
						  @change="toggleEnroll_time_end">
					    </el-date-picker>
				</el-col>
			</el-form-item>
			<el-form-item label="投票规则" prop="rule">
				<el-input type="textarea" v-model="form.rule "></el-input>
			</el-form-item>
			<input type="hidden" v-model="form.state == '' ? 1 : form.state" >
			<el-form-item label="活动封面图" prop="photo">
				<!-- 
					element-loading-background="rgba(250, 250, 250, 0.3)"
					:show-file-list="false"  -->
				<el-upload class="avatar-uploader" :action="picUrl" :show-file-list="false"
					element-loading-text="拼命加载中……" :on-progress="change" :before-upload="beforeAvatarUpload"
					v-loading.fullscreen.lock="loading" :data="fileInfo" :on-success="handleAvatarSuccess"
					accept="image/jpeg,image/png">
					<!-- :onerror="imgSrc"  -->
					<img v-if="imageUrl" :src="imageUrl" :onerror="imgSrc" class="avatar">
					<i v-else class="el-icon-plus avatar-uploader-icon"></i>
				</el-upload>
				<div class="tishinews">
					<!-- 小提示：上传图片只能是JPG/PNG格式且上传图片大小不能超过 5MB！
					<br />图片建议比例:3:2 -->
				</div>
			</el-form-item>
			<el-form-item label="互动详情" prop="content">
				<tinyMce :content="form.content " :change.sync="form.content " />
			</el-form-item>
			<div class="submit-wrap">
				<el-button type="primary" @click="handleSubmit">提交</el-button>
			</div>
		</el-form>
	</div>
</template>

<script>
	import tinyMce from '@/components/plug/tinyMce'
	export default {
		data() {
			return {
				loading: false,
				imgSrc: 'this.src="' + require('../../assets/img/mr.jpg') + '"',
				fileInfo: {
					type: "news",
				},
				vote_time:'',
				vote_time_end:'',
				enroll_time:'',
				enroll_time_end:'',
				user_id: this.$store.state.USER_ID,
				imageUrl: '',
				picUrl:this.$store.state.BASE_URL + '/uploadImgOne.html',
				form: {
					id: '',
					shop_id:this.$store.state.USER_ID,
					title:'',
					vote_time:'',
					vote_time_end:'',
					enroll_time:'',
					enroll_time_end:'',
					rule:'',
					content:'',
					photo:""
				},
				istp:true,
				isbm:true,
				rules: {
					vote_time:[{
						required: true,
						validator: (rule, value, callback) => {
							if (this.form.vote_time === '' || this.form.vote_time_end === '') {
								callback(new Error('请选择投票时间'));
							} else {
								callback();
							}
						}
					}],
					enroll_time:[{
						required: true,
						validator: (rule, value, callback) => {
							if (this.form.enroll_time === ''|| this.form.vote_time_end === '') {
								callback(new Error('请选择报名时间'));
							} else {
								callback();
							}
						}
					}],
					title: [{
						required: true,
						message: '请输入标题'
					}],
					rule:[{
						required: true,
						message: '请输入规则'
					}],
					photo: [{
						required: true,
						message: '请上传图片'
					}],
					content: [{
						required: true,
						validator: (rule, value, callback) => {
							if (this.form.content === '') {
								callback(new Error('请输入详细内容'));
							} else {
								callback();
							}
						}
					}]
				},
			}
		},
		created() {
			
		},
		methods: {
			toggleVotetime(t){
				this.vote_time = t
				this.form.vote_time = t/1000
				// console.log("报名截止时间",this.form.vote_time )
				if(this.vote_time_end > 0){
					if(this.vote_time_end < this.vote_time){
						this.$alert('投票开始时间需小于投票截止时间', '错误提示', {
							type: 'error'
						})
						this.vote_time = ''
						this.form.vote_time = ''
						this.istp = false
					}else{
						this.vote_time = t
						this.form.vote_time = t/1000
					}
				}
			},
			toggleVoteEndTime(t){
				this.vote_time_end = t
				this.form.vote_time_end = t/1000
				if(this.form.vote_time > this.form.vote_time_end){
					this.$alert('投票截止时间需大于投票开始时间', '错误提示', {
						type: 'error'
					})
					this.vote_time_end = ''
					this.form.vote_time_end = ''
					this.istp = false
				}
			},
			toggleEnroll_time(t){
				this.enroll_time = t
				this.form.enroll_time = t/1000
				if(this.enroll_time_end > 0){
					if(this.enroll_time_end < this.enroll_time){
						this.$alert('报名开始时间需小于报名截止时间', '错误提示', {
							type: 'error'
						})
						this.enroll_time = ''
						this.form.enroll_time = ''
						this.istp = false
					}else{
						this.enroll_time = t
						this.form.enroll_time = t/1000
					}
				}
				
			},
			toggleEnroll_time_end(t){
				this.enroll_time_end = t
				this.form.enroll_time_end = t/1000
				if(this.form.enroll_time > this.form.enroll_time_end){
					this.$alert('报名截止时间大于报名开始时间', '错误提示', {
						type: 'error'
					})
					this.enroll_time_end= ''
					this.form.enroll_time_end = ''
					this.istp = false
				}
			},
			// 上传图片
			change(event, file, fileList) {
				this.loading = true;
			},
			beforeAvatarUpload(file) {
				const isJPG = file.type === 'image/jpeg';
				const isPNG = file.type === 'image/png';
				const isLt5M = file.size / 1024 / 1024 < 5;
				if (!isJPG && !isPNG) {
					this.$message.error('上传图片只能是 JPG/PNG 格式!');
				}
				if (!isLt5M) {
					this.$message.error('上传图片大小不能超过 5MB!');
				}
				return (isJPG || isPNG) && isLt5M;
			},
			beforeAvatarUpload(file) {
				const isJPG = file.type === 'image/jpeg';
				const isPNG = file.type === 'image/png';
				const isLt5M = file.size / 1024 / 1024 < 5;
				if (!isJPG && !isPNG) {
					this.$message.error('上传图片只能是 JPG/PNG 格式!');
				}
				if (!isLt5M) {
					this.$message.error('上传图片大小不能超过 5MB!');
				}
				return (isJPG || isPNG) && isLt5M;
			},
			handleAvatarSuccess(res, file) {
				if (res.src != null) {
					this.loading = false;
					this.form.photo = res.src
					this.imageUrl = URL.createObjectURL(file.raw);
				} else {
					this.loading = false;
					this.$message.error(res.data);
				}
			},
			handleSubmit() {
				this.$refs['form'].validate(valid => {
					if (valid) {
						if (this.form.content.includes('"static/tinymce/plugins/bdmap/bd')) {
							this.form.content = this.form.content.replace(
								/"static\/tinymce\/plugins\/bdmap\/bd/g,
								'"/static/tinymce/plugins/bdmap/bd')
						}
						this.$emit('eventForm', this.form)
					} else {
						this.$message.error('请补全必填项')
						return false
					}
				});
			},
		},
		components: {
			tinyMce
		},
		props: {
			newsForm: {
				type: Object,
				default () {
					return {}
				}
			}
		},
		watch: {
			newsForm(val) {
				// console.log("diddd",val)
				this.form = val
				this.form.id = val.id
				this.imageUrl = val.photo ? this.$store.state.IMG_URL + val.photo : ''
				this.vote_time = val.vote_time *1000
				this.vote_time_end = val.vote_time_end *1000
				this.enroll_time = val.enroll_time *1000
				this.enroll_time_end = val.enroll_time_end *1000
				// document.body.scrollTop = document.documentElement.scrollTop = 0
			}
		}
	}
</script>

<style scoped>
	.el-form {
		padding: 20px;
		max-width: 1020px;
	}

	.news-wrap>>>.avatar-uploader .el-upload {
		border: 1px dashed #d9d9d9;
		border-radius: 6px;
		cursor: pointer;
		position: relative;
		overflow: hidden;
	}

	.news-wrap>>>.avatar-uploader .el-upload:hover {
		border-color: #409EFF;
	}

	.news-wrap>>>.avatar-uploader-icon {
		font-size: 28px;
		color: #8c939d;
		width: 178px;
		height: 178px;
		line-height: 178px;
		text-align: center;
	}

	.news-wrap>>>.avatar {
		width: 178px;
		height: 178px;
		display: block;
	}

	.submit-wrap {
		text-align: center;
	}

	.tishinews {
		color: #666ee8;
	}
</style>
